import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { DependencyTracker2tg9lout2xnpn as DependencyTracker } from './DependencyTracker.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  onThread26qoqfscmlcbk as onThread,
  Key_instance6wd16m35aua5 as Key_instance,
} from './CalculationContext.mjs';
import {
  _ReactiveState___init__impl__fvdp9b2eqyidpf491cp as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance1a6q7ejsqzzhs as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya10f5f3x6hwqt0 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotReadygki7zhqkkp9u as InternalReactiveNotReady,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
  InternalReactiveNotReady_instance37iasaqvolrrz as InternalReactiveNotReady_instance,
} from '../core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../core/coreInterfaces.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var reactiveContext;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var OnceClass;
function Once() {
  if (OnceClass === VOID) {
    class $ {
      constructor(wraps) {
        this.qai_1 = wraps;
      }
      toString() {
        return 'Once(wraps=' + toString(this.qai_1) + ')';
      }
      hashCode() {
        return hashCode(this.qai_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Once()))
          return false;
        if (!equals(this.qai_1, other.qai_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Once');
    OnceClass = $;
  }
  return OnceClass;
}
function TypedReactiveContext$startCalculation$ref(p0) {
  var l = () => {
    p0.aaj();
    return Unit_instance;
  };
  l.callableName = 'startCalculation';
  return l;
}
function TypedReactiveContext$once$lambda() {
  return Unit_instance;
}
var TypedReactiveContextClass;
function TypedReactiveContext() {
  if (TypedReactiveContextClass === VOID) {
    class $ extends DependencyTracker() {
      constructor(scope, useLastWhileLoading, reportTo, action) {
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        reportTo = reportTo === VOID ? RawReactive().aai() : reportTo;
        super();
        this.tai_1 = scope;
        this.uai_1 = useLastWhileLoading;
        this.vai_1 = reportTo;
        this.wai_1 = action;
        this.xai_1 = false;
        var tmp = this;
        tmp.yai_1 = TypedReactiveContext$startCalculation$ref(this);
        this.zai_1 = false;
        onRemove(this.tai_1, () => {
          this.nai();
          return Unit_instance;
        });
      }
      aaj() {
        this.xai_1 = true;
        if (this.zai_1)
          return Unit_instance;
        this.zai_1 = true;
        onThread(this.tai_1, () => {
          this.zai_1 = false;
          var tmp;
          if (!this.xai_1) {
            return Unit_instance;
          }
          var old = reactiveContext;
          reactiveContext = this;
          this.oai();
          // Inline function 'com.lightningkite.reactive.core.reactiveState' call
          var tmp_0;
          try {
            var tmp$ret$0 = this.wai_1(this);
            tmp_0 = _ReactiveState___init__impl__fvdp9b(tmp$ret$0);
          } catch ($p) {
            var tmp_1;
            if ($p instanceof CancellationException()) {
              var _unused_var__etf5q3 = $p;
              tmp_1 = Companion_getInstance().oah_1;
            } else {
              if ($p instanceof ReactiveLoading()) {
                var _unused_var__etf5q3_0 = $p;
                tmp_1 = Companion_getInstance().oah_1;
              } else {
                if ($p instanceof Exception()) {
                  var e = $p;
                  tmp_1 = Companion_getInstance().wah(e);
                } else {
                  throw $p;
                }
              }
            }
            tmp_0 = tmp_1;
          }
          var state = tmp_0;
          var tmp_2;
          var tmp_3;
          if (!this.uai_1) {
            tmp_3 = true;
          } else {
            // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
            var tmp_4 = _ReactiveState___get_raw__impl__92ipya(state);
            tmp_3 = !(tmp_4 instanceof InternalReactiveNotReady());
          }
          if (tmp_3) {
            this.vai_1.rah(state);
            tmp_2 = Unit_instance;
          }
          this.pai();
          reactiveContext = old;
          return Unit_instance;
        });
      }
      baj() {
        // Inline function 'com.lightningkite.reactive.core.reactiveState' call
        var tmp;
        try {
          var tmp$ret$0 = this.wai_1(this);
          tmp = _ReactiveState___init__impl__fvdp9b(tmp$ret$0);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof CancellationException()) {
            var _unused_var__etf5q3 = $p;
            tmp_0 = Companion_getInstance().oah_1;
          } else {
            if ($p instanceof ReactiveLoading()) {
              var _unused_var__etf5q3_0 = $p;
              tmp_0 = Companion_getInstance().oah_1;
            } else {
              if ($p instanceof Exception()) {
                var e = $p;
                tmp_0 = Companion_getInstance().wah(e);
              } else {
                throw $p;
              }
            }
          }
          tmp = tmp_0;
        }
        var state = tmp;
        var tmp_1;
        if (!this.uai_1) {
          tmp_1 = true;
        } else {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
          var tmp_2 = _ReactiveState___get_raw__impl__92ipya(state);
          tmp_1 = !(tmp_2 instanceof InternalReactiveNotReady());
        }
        if (tmp_1) {
          this.vai_1.rah(state);
        }
      }
      nai() {
        this.xai_1 = false;
        this.zai_1 = false;
        super.nai();
      }
      caj(listenable) {
        if (!(this.lai(listenable) == null))
          return Unit_instance;
        this.mai(listenable, listenable.vah(this.yai_1));
      }
      daj(_this__u8e3s4) {
        if (this.lai(_this__u8e3s4) == null) {
          this.mai(_this__u8e3s4, _this__u8e3s4.vah(this.yai_1));
        }
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = _this__u8e3s4.sah();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          throw ReactiveLoading_getInstance();
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            throw _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
              tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            } else {
              tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
            }
          }
        }
        return tmp;
      }
      eaj(_this__u8e3s4) {
        if (this.lai(_this__u8e3s4) == null) {
          this.mai(_this__u8e3s4, _this__u8e3s4.vah(this.yai_1));
        }
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = _this__u8e3s4.sah();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          throw ReactiveLoading_getInstance();
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            throw _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
              var tmp0_elvis_lhs = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
              var tmp_1;
              if (tmp0_elvis_lhs == null) {
                throw ReactiveLoading_getInstance();
              } else {
                tmp_1 = tmp0_elvis_lhs;
              }
              tmp = tmp_1;
            } else {
              var tmp0_elvis_lhs_0 = _ReactiveState___get_raw__impl__92ipya(this_0);
              var tmp_2;
              if (tmp0_elvis_lhs_0 == null) {
                throw ReactiveLoading_getInstance();
              } else {
                tmp_2 = tmp0_elvis_lhs_0;
              }
              tmp = tmp_2;
            }
          }
        }
        return tmp;
      }
      faj(_this__u8e3s4) {
        if (this.lai(_this__u8e3s4) == null) {
          this.mai(_this__u8e3s4, _this__u8e3s4.vah(this.yai_1));
        }
        return _this__u8e3s4.sah();
      }
      gaj(_this__u8e3s4) {
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
        var this_0 = _this__u8e3s4.sah();
        var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
        var tmp;
        if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
          var key = new (Once())(_this__u8e3s4);
          if (this.lai(key) == null) {
            var remover = {_v: TypedReactiveContext$once$lambda};
            remover._v = _this__u8e3s4.vah(() => {
              remover._v();
              this.yai_1();
              return Unit_instance;
            });
            this.mai(key, remover._v);
          }
          throw ReactiveLoading_getInstance();
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            throw _ReactiveState___get_raw__impl__92ipya(this_0).uah_1;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              var tmp_0 = _ReactiveState___get_raw__impl__92ipya(this_0).tah_1;
              tmp = (tmp_0 == null ? true : !(tmp_0 == null)) ? tmp_0 : THROW_CCE();
            } else {
              tmp = _ReactiveState___get_raw__impl__92ipya(this_0);
            }
          }
        }
        return tmp;
      }
      haj(_this__u8e3s4) {
        return this.daj(_this__u8e3s4);
      }
      iaj(_this__u8e3s4) {
        return this.gaj(_this__u8e3s4);
      }
      ga2() {
        return this.tai_1.ga2();
      }
      sah() {
        return this.vai_1.sah();
      }
      vah(listener) {
        return this.vai_1.vah(listener);
      }
      kaj() {
        return this.vai_1.kaj();
      }
    }
    initMetadataForClass($, 'TypedReactiveContext', VOID, VOID, [DependencyTracker(), CoroutineScope(), Reactive()]);
    TypedReactiveContextClass = $;
  }
  return TypedReactiveContextClass;
}
function reactive(_this__u8e3s4, action) {
  var trc = new (TypedReactiveContext())(_this__u8e3s4, VOID, VOID, action);
  trc.aaj();
  var tmp0_safe_receiver = _this__u8e3s4.ga2().cd(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    tmp0_safe_receiver.eah(trc);
  }
  return trc;
}
function reactiveScope(_this__u8e3s4, action) {
  return reactive(_this__u8e3s4, action);
}
var ReactiveLoadingClass;
function ReactiveLoading() {
  if (ReactiveLoadingClass === VOID) {
    class $ extends Error {
      constructor() {
        ReactiveLoading_instance = null;
        super(null);
        ReactiveLoading_instance = this;
        setPropertiesToThrowableInstance(this);
        captureStack(this, this.laj_1);
      }
    }
    initMetadataForObject($, 'ReactiveLoading');
    ReactiveLoadingClass = $;
  }
  return ReactiveLoadingClass;
}
var ReactiveLoading_instance;
function ReactiveLoading_getInstance() {
  if (ReactiveLoading_instance === VOID)
    new (ReactiveLoading())();
  return ReactiveLoading_instance;
}
//region block: init
reactiveContext = null;
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  ReactiveLoading as ReactiveLoadings35224pps2d9,
  TypedReactiveContext as TypedReactiveContextwc1z7epz7cib,
  reactiveScope as reactiveScope1fcalsbdr0hgb,
  reactive as reactive2pl1t9wy5gll5,
  ReactiveLoading_getInstance as ReactiveLoading_getInstance37x995i6zd62h,
};
//endregion

//# sourceMappingURL=ReactiveContext.mjs.map
